import gql from 'graphql-tag';

export default gql`
mutation deleteTag($tagId: Int!) {
  delete_tags(where: {tag_id: {_eq: $tagId}}) {
    affected_rows
  }
}
`;
